const basePath = '/trade';

export const tradeRoutePaths = {
  root: basePath,
  salesOrders: `${basePath}/orders`,
  salesOrderDetail: `${basePath}/orders/:id`,
  purchaseOrders: `${basePath}/purchase-orders`,
  purchaseOrderDetail: `${basePath}/purchase-orders/:id`,
  bookings: `${basePath}/bookings`,
  bookingDetail: `${basePath}/bookings/:id`,
  loads: `${basePath}/loads`,
  loadDetail: `${basePath}/loads/:id`,
  containers: `${basePath}/containers`,
  containerDetail: `${basePath}/containers/:id`,
  positions: `${basePath}/positions`,
  scaleTickets: `${basePath}/scale-tickets`,
  scaleTicketDetail: `${basePath}/scale-tickets/:id`,
  transactions: `${basePath}/transactions`,
  sortingQueue: `${basePath}/sorting`,
} as const;

// Alias for backwards compatibility
export const salesRoutes = tradeRoutePaths;
